import request from '@/utils/request';

/**
 * 获取用户基本信息
 */
export function getAppsBasicInfo () {
  return request('/user/apps/getAppsBasicInfo?path=/');
}

/**
 * 获取环境变量信息
 */
export function getEnvHref () {
  return request('/api/privileges/getEnvHref');
}

/**
 * 获取首页用户基本信息
 * @param {*} orgId 用户机构id
 */
export function getUseProfile (orgId) {
  return request(`/api/eco/item/getUseProfile`, {
    params: {
      orgId
    }
  });
}

/**
 * 获取应用详情
 * @param {*} appID 应用id
 */
export function getItemDetails (appID) {
  return request('/api/eco/item/itemDetails');
}

/**
 * 获取类目
 * @param {*} pid 类目父节点id
 */
export function getFrontCategory (pid) {
  return request('/api/eco/base/getFrontCategory', {
    params: {
      pid
    }
  });
}
/**
 * 搜索
 */
export function searchApi (params) {
  return request('/api/eco/item/search', {
    method: 'POST',
    data: params
  });
}

/**
 * 获取应用的基本信息
 * @param {*} appId 应用id
 */
export function getAppItemDetails (appId) {
  return request('/api/eco/item/itemDetails', {
    params: {
      appId
    }
  });
}

/**
 * 获取应用的销售信息
 * @param {*} appId 应用id
 */
export function getAppSalesInfo (appId) {
  return request('/api/eco/item/getSaasAppItemSalesInfo', {
    params: {
      appId
    }
  });
}

/**
 * 获取应用解决方案等，用户案例等信息
 * @param {*} appId 应用id
 * @param {*} imgType 301:"解决方案"; 302:"应用截图"; 304:"使用手册"; 303:"用户案例"
 */
export function getImages (appId, imgType) {
  return request('/api/eco/item/images', {
    params: {
      appId,
      imgType
    }
  });
}

/**
 * 获取首页精品应用，热门应用和最新应用
 */
export function getHomePageApps () {
  return request('/api/eco/item/gerHomePageApps');
}

/**
 * 获取登录状态
 */
export function getLoginStatus () {
  return request('/api/eco/front/getSupplierEnterStatus');
}

/**
 * 店铺搜索列表
 */
export function getSaasShopListApi (params) {
  return request('/api/eco/shop/getSaasShopList', {
    method: 'POST',
    data: params
  });
}
/**
 * 获取店铺头部详情
 */
export function shopDetailApi (supplierId) {
  return request('/api/eco/shop/getSaasShopDetail', {
    params: {
      supplierId
    }
  });
}
/**
 * 获取店铺信息
 */
export function getShopDetail (supplierId) {
  return request('/api/eco/shop/getSaasShopDetail', {
    params: {
      supplierId
    }
  });
}

/**
 * 获取使用信息
 * @param {*} appId 应用id
 */
export function getOperationManual (appId) {
  return request('/api/eco/item/operationManual', {
    params: {
      appId
    }
  });
}

/**
 * 获取预览url
 * @param {*} appId 应用id
 */
export function getViewOperationManual (appId) {
  return request('/api/eco/item/viewOperationManual', {
    params: {
      appId
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/index.js